'use client'

import { QuickSearchResponseRecord } from '@/search/types'
import { ProductResultItem } from './resultRenderers/ProductResultItem'

interface SearchResultItemProps {
  result: QuickSearchResponseRecord
  isActive: boolean
  onClick: () => void
  onMouseEnter: () => void
  onMouseLeave: () => void
}

export const SearchResultItem = ({
  result,
  isActive,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: SearchResultItemProps) => {
  // For now, only products are supported
  // Future: Add BlogPostResultItem and PageResultItem renderers
  const resultType = result.resultType || 'product'

  if (resultType === 'product') {
    return (
      <ProductResultItem
        result={result}
        isActive={isActive}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    )
  }

  // Future: Add blog and page renderers here
  // For now, fallback to product renderer
  return (
    <ProductResultItem
      result={result}
      isActive={isActive}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  )
}

